import { columnSettings } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const { mykey, no, tanggal, durasi, label_grup, keterangan } = props;

  return (
    <tr
      key={mykey}
      className="row-start-start w-full text-sm text-slate-700 !items-stretch"
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["tanggal"].layout} ${settings["tanggal"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {tanggal ? format(new Date(tanggal), settings["tanggal"].format) : "-"}
      </td>

      <td
        className={`${settings["durasi"].layout} ${settings["durasi"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {durasi ? durasi.toLocaleString("id-ID") : "-"}
      </td>

      <td
        className={`${settings["label_grup"].layout} ${settings["label_grup"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {label_grup}
      </td>

      <td
        className={`${settings["keterangan"].layout} ${settings["keterangan"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {keterangan}
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
